import React from 'react';
import { createAxios, logNative } from '../../utils/utils';
import {
  WP_ADD_TO_TURN_85,
  WP_DEL_TO_TURN_85,
  WP_GET_ORDER_SKU_LIST_85,
  WP_PRODUCT_PAY_CREATE_80,
  WP_UNSUBSCRIBE_85,
  WP_VIP_STATE_85,
  WP_BATCH_ADD_87,
  WP_BATCH_SHOW_87,
} from '../../config';

export default {
  async addWpToTurn(params) {
    try {
      const axios = await createAxios('isNeedUser');
      const res = await axios.post(WP_ADD_TO_TURN_85, { ...params });
      return res?.data;
    } catch (err) {
      logNative(
        `壁纸请求，添加壁纸到轮播列表请求失败 params:${JSON.stringify(params)} err: ${err}`,
      );
    }
  },
  async delWpToTurn(params) {
    try {
      const axios = await createAxios('isNeedUser');
      const res = await axios.post(WP_DEL_TO_TURN_85, { ...params });
      return res?.data;
    } catch (err) {
      logNative(
        `壁纸请求，添加壁纸到轮播列表请求失败 params:${JSON.stringify(params)} err: ${err}`,
      );
    }
  },
  async getOrderSku(params) {
    try {
      const axios = await createAxios('isNeedUser');
      const res = await axios.get(WP_GET_ORDER_SKU_LIST_85, { params: params });
      return res?.data;
    } catch (err) {
      logNative(`获取壁纸订单列表失败 params:${JSON.stringify(params)} err: ${err}`);
    }
  },
  async createOrder(params) {
    try {
      const axios = await createAxios('isNeedUser');
      const res = await axios.post(WP_PRODUCT_PAY_CREATE_80, { ...params });
      return res?.data;
    } catch (err) {
      logNative(`生成壁纸订单失败 params:${JSON.stringify(params)} err: ${err}`);
    }
  },
  async orderPayResult(params) {
    try {
      const axios = await createAxios('isNeedUser');
      const res = await axios.get(params.queryUrl, { params: params });
      return { ...res?.data, time: +new Date() };
    } catch (err) {
      logNative(`验证壁纸订单支付成功接口调用失败 params:${JSON.stringify(params)} err: ${err}`);
    }
  },
  async unsubscribe(params) {
    try {
      const axios = await createAxios('isNeedUser');
      const res = await axios.get(WP_UNSUBSCRIBE_85);
      return res?.data;
    } catch (err) {
      logNative(`取消连续订阅失败失败 params:${JSON.stringify(params)} err: ${err}`);
    }
  },
  async againGetVip() {
    try {
      const axios = await createAxios('isNeedUser');
      const res = await axios.get(WP_VIP_STATE_85);
      if (res?.data?.data?.vipState === 0) {
        return true;
      }
      return false;
    } catch (err) {
      return false;
    }
  },
  async batchAdd(param) {
    try {
      const axios = await createAxios('isNeedUser');
      const res = await axios.post(WP_BATCH_ADD_87, { ...param });
      return res.data;
    } catch (err) {
      return false;
      logNative(`批量添加轮播失败 params:${JSON.stringify(param)} err: ${err}`);
    }
  },
  async batchAddShow(param) {
    try {
      const axios = await createAxios('isNeedUser');
      const res = await axios.post(WP_BATCH_SHOW_87, { ...param });
      return res.data;
    } catch (err) {
      logNative(`是否添加过该分类获取失败 params:${JSON.stringify(param)} err: ${err}`);
    }
  },
};
